import { Form } from 'utils/hooks'
import { Flex } from 'components/shared/flex'
import { PancreasTestResultV2Form } from 'api/result'
import { CheckboxField, DateField, MultipleSelectField, RangeField, SelectField } from 'components/shared/input'
import { ProductItem } from 'entities/product_item'
import { Symptom } from '../result_v2'

type PancreasTestViewProps = {
    form: Form<PancreasTestResultV2Form>
    formPrev: Form<PancreasTestResultV2Form>
    formPrev2: Form<PancreasTestResultV2Form>
    productItem: ProductItem
    symptoms: Symptom[]
}

export const PancreasTestView = ({ form, formPrev, formPrev2, productItem, symptoms }: PancreasTestViewProps) => {
    return (
        <>
            <div style={{ padding: 10 }}>
                <div>状態</div>
                <Flex style={{ fontSize: 14 }}>
                    <CheckboxField form={form} attr={'menstruation'} checkboxLabel="生理中" />
                    <CheckboxField form={form} attr={'pregnancy'} checkboxLabel="妊娠中" />
                </Flex>
            </div>
            <div style={{ padding: 10 }}>
                <div>疑いのある症状</div>

                <div style={{ fontSize: 14 }}>
                    <MultipleSelectField
                        id="pancreas-symptoms"
                        form={form}
                        attr="symptoms"
                        selectItems={symptoms.filter((s) => s.products.includes('pancreas')).map((s) => s)}
                        hideSearch
                        horizontal
                        hideSelectAll
                    />
                </div>
            </div>
            <div>
                <PancreasControlForm form={form} title="今回" color="#9002" hideEnableCheck productItem={productItem} />
                <PancreasControlForm form={formPrev} title="前回" color="#9002" productItem={productItem} />
                <PancreasControlForm form={formPrev2} title="前々回" color="#9002" productItem={productItem} />
            </div>
        </>
    )
}
type PancreasControlFormProps = {
    form: Form<PancreasTestResultV2Form>
    title: string
    color: string
    hideEnableCheck?: boolean
    productItem: ProductItem
}

const PancreasControlForm = ({ form, title, color, hideEnableCheck, productItem }: PancreasControlFormProps) => {
    const enabled = form.object.enabled

    return (
        <div style={{ padding: 20, backgroundColor: color, width: '100%' }}>
            <Flex style={{}}>
                <div style={{ fontWeight: 'bold' }}>{title}</div>
                {!hideEnableCheck && (
                    <div>
                        <CheckboxField form={form} attr="enabled" checkboxLabel="有効" controlId={title} />
                    </div>
                )}
            </Flex>
            {form.object.enabled && (
                <>
                    <Flex>
                        <DateField form={form} attr="deliveryDate" label="検査日" style={{ marginBottom: 0 }} />
                    </Flex>
                    {form.object.useCt ? (
                        <div>
                            <div style={{ backgroundColor: '#fff5', padding: 5 }}>
                                <div style={{ fontWeight: 'bold' }}>HK</div>
                                <div style={{ padding: 10 }}>
                                    {productItem.qcVersion?.protocolVersionProbes
                                        ?.filter((pvp) => pvp.qcType === 'HK')
                                        .map((pvp, index) => {
                                            return (
                                                <RangeField
                                                    key={'range-' + index}
                                                    form={form}
                                                    attr={['hkCts', pvp.probe!.name!]}
                                                    min={0}
                                                    max={40}
                                                    label={`${pvp.probe?.name} CT =`}
                                                    showValue
                                                    step={0.01}
                                                />
                                            )
                                        })}
                                </div>
                            </div>
                            <div style={{ backgroundColor: '#fff5', marginTop: 10, padding: 5 }}>
                                <div style={{ fontWeight: 'bold' }}>Bio marker</div>
                                <div style={{ padding: 10 }}>
                                    {productItem.currentProtocolVersion?.protocolVersionProbes?.map((pvp, index) => {
                                        return (
                                            <RangeField
                                                key={'range-' + index}
                                                form={form}
                                                attr={['markerCts', pvp.probe!.name!]}
                                                min={0}
                                                max={40}
                                                label={`${pvp.probe?.name} CT =`}
                                                showValue
                                                step={0.01}
                                            />
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <RangeField
                            form={form}
                            attr="baseScore"
                            label="機械学習スコア"
                            min={0}
                            max={1}
                            step={0.001}
                            disabled={!enabled}
                            style={{ marginBottom: 0 }}
                            showValue
                        />
                    )}
                    <RangeField form={form} attr="age" label="年齢" disabled={!enabled} min={0} max={100} step={5} style={{ marginBottom: 0 }} showValue />
                    <Flex>
                        <RangeField
                            form={form}
                            attr="height"
                            label="身長"
                            disabled={!enabled}
                            min={100}
                            max={200}
                            step={5}
                            style={{ marginBottom: 0 }}
                            showValue
                        />
                        <RangeField
                            form={form}
                            attr="weight"
                            label="体重"
                            disabled={!enabled}
                            min={30}
                            max={120}
                            step={5}
                            style={{ marginBottom: 0 }}
                            showValue
                        />
                    </Flex>

                    <SelectField
                        form={form}
                        attr="bloodType"
                        label="血液型"
                        selectItems={[
                            { label: 'A', value: 'A' },
                            { label: 'B', value: 'B' },
                            { label: 'O', value: 'O' },
                            { label: 'AB', value: 'AB' },
                            { label: '不明', value: 'unknown' },
                        ]}
                    />
                    <SelectField
                        form={form}
                        attr="alcoholPerWeek"
                        label="飲酒歴"
                        selectItems={[
                            { label: 'なし', value: 0 },
                            { label: '週1日未満', value: 0.5 },
                            { label: '週1日', value: 1 },
                            { label: '週2日', value: 2 },
                            { label: '週3日', value: 3 },
                            { label: '週4日', value: 4 },
                            { label: '週5日', value: 5 },
                            { label: '週6日', value: 6 },
                            { label: '毎日', value: 7 },
                        ]}
                    />
                    <Flex>
                        <SelectField
                            form={form}
                            attr="smoking"
                            label="喫煙歴"
                            selectItems={[
                                { label: 'なし', value: 'never' },
                                { label: '過去に吸っていた', value: 'ever' },
                                { label: '吸っている', value: 'now' },
                            ]}
                        />
                    </Flex>

                    {form.object.smoking === 'now' && (
                        <Flex>
                            <RangeField form={form} attr="smokingAmount" label="1日の本数" step={10} min={0} max={60} showValue />
                            <RangeField form={form} attr="smokingYears" label="喫煙年数" step={10} min={0} max={50} showValue />
                        </Flex>
                    )}
                    {form.object.smoking === 'ever' && (
                        <Flex>
                            <RangeField form={form} attr="noSmokingPeriod" label="禁煙年数" step={10} min={0} max={50} showValue />
                        </Flex>
                    )}

                    <div style={{ marginTop: 10 }}>
                        <div>
                            <div>既往歴</div>
                            <div>
                                <CheckboxField
                                    form={form}
                                    attr="diabetes"
                                    checkboxLabel="糖尿病"
                                    disabled={!enabled}
                                    controlId={title}
                                    style={{ marginBottom: 0 }}
                                />
                                <CheckboxField
                                    form={form}
                                    attr="chronicPancreatitis"
                                    checkboxLabel="慢性膵炎"
                                    disabled={!enabled}
                                    controlId={title}
                                    style={{ marginBottom: 0 }}
                                />
                                <CheckboxField
                                    form={form}
                                    attr="pancreaticCyst"
                                    checkboxLabel="膵嚢胞"
                                    disabled={!enabled}
                                    controlId={title}
                                    style={{ marginBottom: 0 }}
                                />
                                <CheckboxField
                                    form={form}
                                    attr="gastricUlcer"
                                    checkboxLabel="胃潰瘍"
                                    disabled={!enabled}
                                    controlId={title}
                                    style={{ marginBottom: 0 }}
                                />
                                <CheckboxField
                                    form={form}
                                    attr="periodontalDisease"
                                    checkboxLabel="歯周病"
                                    disabled={!enabled}
                                    controlId={title}
                                    style={{ marginBottom: 0 }}
                                />
                            </div>
                        </div>
                        <div style={{ marginTop: 10 }}>
                            <div>家族歴</div>
                            <div>
                                <RangeField
                                    showValue
                                    form={form}
                                    attr="firstDegreeRelative"
                                    label="第一度近親者の数"
                                    disabled={!enabled}
                                    step={1}
                                    min={0}
                                    max={5}
                                />
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}
